export default "query genders{\n    genders\n}";